import { render, staticRenderFns } from "./IdentityDocumentList.vue?vue&type=template&id=3cec6d42&scoped=true&"
import script from "./IdentityDocumentList.vue?vue&type=script&lang=js&"
export * from "./IdentityDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./IdentityDocumentList.vue?vue&type=style&index=0&id=3cec6d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec6d42",
  null
  
)

export default component.exports